// namespace
export const SURVEY = 'survey'
export const SURVEY_SINGAPORE = 'surveySingapore'
export const SURVEY_SYDNEY = 'surveySydney' 
export const SURVEY_SAPPORO = 'surveySapporo' 

// getters
export const MAIN_RESPONSES = 'mainResponses'
export const FAMILY_RESPONSES = 'familyResponses'
export const ATTENDING_LIST = 'attendingList'
export const EXIST_ATTENDANT = 'existAttendant'
export const SPOUSE_ATTENDANTS = 'spouseAttendants'
export const MEMBER_ATTENDANTS = 'memberAttendants'
export const FAMILY_ATTENDANTS = 'familyAttendants'
export const COMMON_QUESTIONS = 'commonQuestions'
export const INFO_QUESTIONS = 'infoQuestions'
export const ACTIVITY_QUESTIONS = 'activityQuestions'
export const SCHEDULE_QUESTIONS = 'scheduleQuestions'  // 일정에 관련된 질문 
export const REQUIRED_CONSENTS = 'requiredConsents'
export const OPTIONAL_CONSENTS = 'optionalConsents'
export const GET_DATA_IDX_BY_TYPE = 'getDataIdxByType'
export const GET_RESPONSE_DATA = 'getResponseData'
export const GET_DEFAULT_CONSENTS_RESPONSE = 'getDefaultConsentsResponse'
export const GET_DEFAULT_QUESTIONS_RESPONSE = 'getDefaultQuestionsResponse'
export const GET_DEFAULT_ACTIVITY_RESPONSE = 'getDefaultActivityResponse'
export const GET_ORIGINAL_IDX_BY_SEQ = 'getOriginalIndexBySequence'
export const GET_ORIGINAL_ATTENT_YN = 'getOriginalAttentYn'
export const GET_NEW_FAMILY = 'getNewFamily'
export const GET_FAMILY_INDEX = 'getFamilyIndex'
export const IS_FAMILY_NEED_PAYMENT = 'isFamilyNeedPayment'
export const NUMBER_OF_ATTENDEES = 'numberOfAttendees'
export const INFO_AVAILABLE = 'infoAvailable'
export const ACTIVITY_AVAILABLE = 'activityAvailable'
export const NEED_FAMILY_RELATION_DOCUMENT = 'needFamilyRelationDocument'
export const NEED_FAMILY_DOCUMENT = 'needFamilyDocument'
export const FAMILY_ATTENDANCE_YN = 'familyAttendanceYn'
export const IS_VIP = 'isVip'

export const GET_CODE_COUNTRY = 'getCodeCountry' // 공통코드 조회 : 국가
export const GET_CODE_ABO_TYPE = 'getCodeAboType' // 공통코드 조회 : ABO 유형
export const GET_CODE_GENDER = 'getCodeGender' // 공통코드 조회 : 성별
export const GET_CODE_MINOR_AGE_YMD = 'getCodeMinorAgeYmd' // 공통코드 조회 : 미성년자년월일
export const GET_CODE_TODAY= 'getCodeTodayYmd' // 공통코드 조회 : 오늘날짜 
export const GET_CODE_PASSPORT_DATE= 'getCodePassportYmd' // 공통코드 조회 : 여권일자
export const GET_NAME_OF_INDEX = 'getNameOfIndex' // 참여자 이름 seq 
export const GET_CODE_FAMILY_REL = 'getCodeFamilyRelation' // 가족관계 
export const GET_CODE_PAYMENT_GUIDE = 'getCodePaymentGuide' // 결제관련정보 
export const GET_PAYMENT_TYPE = 'getPaymentType'
export const GET_PAYMENT_REMARK = 'getPaymentRemark'

// 삿포로
export const GET_CODE_SHOE_SIZE = 'getCodeShoeSize'; // 공통코드 신발사이즈
export const GET_CODE_SPORT_LEVEL = 'getCodeSportLevel'; // 공통코드 스포츠레벨
export const GET_PERSONS_EXCLUDING_FAMILY = 'getPersonsExcludingFamily'; //직계가족이 아닌 구성원수 
// mutations
export const SET_INIT_COMPLETED = 'setInitCompleted'
export const SET_ABO_UID = 'setAboUid'
export const SET_PIN_LEVEL = 'setPinLevel'
export const SET_BASIC_DATA = 'setBasicData'
export const SET_RESPONSE_DATAS = 'setResponseDatas'
export const SET_ORIGINALS = 'setOriginals'
export const SET_RESPONSES_FOR_DELETE = 'setResponsesForDelete'
export const SET_CONSENTS = 'setConsents'
export const SET_QUESTIONS = 'setQuestions'
export const SET_COMMONS = 'setCommons'
export const SET_SCHEDULE = 'setSchedule' // 기존 일정 설문에 대한 설정 
export const SET_MODE = 'setMode'
export const SET_POPUP_CONTENT = 'setPopupContent'
export const TOGGLE_POPUP = 'togglePopup'
export const TOGGLE_INTEREST_FEE_POPUP = 'toggleInterestFeePopup'
export const TOGGLE_ACTIVITY_POPUP = 'toggleActivityPopup'
export const SET_LOADING = 'setLoading'
export const SET_ACTIVITY_REMAIN_NUM = 'setActivityRemainNumber'
export const SET_FILES_FOR_DELETE = 'setFilesForDelete'

export const SET_NAME = 'setName'
export const SET_ATTENDANCE = 'setAttendance'
export const SET_CONSENT_YN = 'setConsentYn'
export const SET_QUESTION_ANSWER = 'setQuestionAnswer'
export const SET_CHOICE_QUESTION = 'setChoiceQuestionAnswer'
export const RESET_CHOICE_QUESTION = 'resetChoiceQuestionAnswer'
export const SET_FAMILY_ATTENDANCE_YN = 'setFamilyAttendanceYn'
export const SET_PAYMENT_INFO = 'setPaymentInfo'
export const SET_COMMON_DATA = 'setCommonData'
export const SET_ORIGINAL_COMMON_DATA = 'setOriginalCommonData'

export const SET_CODES = 'setCodes' // 공통코드 설정  
export const SET_HINT = 'setHint' // 오입력 힌트 표시 여부 

export const SET_PAYMENT_TYPE = 'setPaymentType' // 결제방식
export const SET_PAYMENT_REMARK = 'setPaymentRemark' // 결제메모 (연락처)

// actions
export const FETCH_ABO_INFO = 'fetchAboInfo'
export const FETCH_SURVEY_INFO = 'fetchSurveyInfo'
export const FETCH_DATAS = 'fetchDatas'
export const INIT_DATAS = 'initDatas'
export const CLEAR_RESPONSE_DATA = 'clearResponseData'
export const OPEN_POPUP = 'openPopup'
export const CLOSE_POPUP = 'closePopup'
export const VALIDATE_DATA = 'validateData'
export const SUBMIT_SURVEY = 'submitSurvey'
export const FIRST_SUBMIT = 'firstSubmit'
export const SAVE_SUBMIT = 'saveSubmit'
export const UPDATE_ACTIVITY_REMAIN_NUM = 'updateActivityRemainNumber'
export const ADD_NEW_FAMILY = 'addNewFamily'
export const REMOVE_FAMILY = 'removeFamily'
export const CLEAR_COMMON_DATA = 'clearCommonData'
export const SELECT_CHOICE_DATA = 'selectChoiceData'
export const SELECT_SCHEDULE_DATA = 'selectReturnScheduleData' // 일정에 대한 기존 선택정보 

export const FETCH_CODES = 'fetchCode' // 공통코드 조회 API
export const GET_QUESTIONS = 'getQuestions'

export const FETCH_DOWNLOAD_FILE = 'fetchDownloadFile'